export default __webpack_public_path__ + "static/media/404.0f9ac772.png";